import { useState } from "react";
import { useAuthContext } from "../../context/AuthContext";
import { API } from "../../constant";
import { getToken } from "../../helpers";
import logo2 from "../../Media/LogoReverseWithTag.svg";
import Footer from "../Footer/Footer";
import Loading from "../Hooks/Loading";

const Profile = () => {
  const [loading, setLoading] = useState(false);
  const [profileMessage, setProfileMessage] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const { user, setUser } = useAuthContext();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  let userName;
  let emailaddr;
  if(user != undefined){
    userName = user.username;
    emailaddr = user.email;
  }

  const handleProfileUpdate = async (values) => {
    setLoading(true);
    setProfileMessage("");
    const formValues = {};
    const formData = new FormData(values.target);
    formData.forEach((value, key) => formValues[key] = value);
    values.preventDefault();

    // Remove password field from profile update
    delete formValues.password;

    console.log(JSON.stringify(formValues));

    try {
      const response = await fetch(`${API}/users/${user.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(formValues),
      });
      const responseData = await response.json();

      if(response.ok){
        setUser(responseData);
        setProfileMessage("Profile updated successfully!");
        console.log("Data saved successfully!");
      } else {
        setProfileMessage("Error updating profile. Please try again.");
      }
    } catch (error) {
      console.error(error);
      setProfileMessage("Error updating profile. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setPasswordMessage("");
    setPasswordError("");

    // Validate passwords
    if (!currentPassword || !newPassword || !confirmPassword) {
      setPasswordError("Please fill in all password fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setPasswordError("New passwords do not match.");
      return;
    }

    if (newPassword.length < 6) {
      setPasswordError("New password must be at least 6 characters long.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API}/auth/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          currentPassword: currentPassword,
          password: newPassword,
          passwordConfirmation: confirmPassword,
        }),
      });

      const responseData = await response.json();

      if(response.ok){
        setPasswordMessage("Password changed successfully!");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        setPasswordError(responseData.error?.message || "Error changing password. Please check your current password.");
      }
    } catch (error) {
      console.error(error);
      setPasswordError("Error changing password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const showPassword = (e) => {
    let inputval = e.target.previousSibling.getAttribute("type");
    if(inputval === "password"){
      e.target.previousSibling.setAttribute("type", "text");
      e.target.classList.remove("hide");
    } else {
      e.target.previousSibling.setAttribute("type", "password");
      e.target.classList.add("hide");
    }
  };

  return (
    <div className="skills">
      <div className="container">
        {loading && <Loading />}

        <div className="content-wrap bg-blue">
          <div className="quick-cope">
            <div className="profile-area-inner ctr">
              <img src={logo2} alt="profile"/>
              <h2 className="mt---30">Change Password</h2>

              {/* Profile Update Form */}
              <div className="theme-form">
                <form onSubmit={handleProfileUpdate}>
                  <label className="input-field user disabled">
                    <input className="field-with-icon" type="text" name='username' placeholder="Enter Your Username" defaultValue={userName} />
                  </label>
                  <label className="input-field email disabled">
                    <input className="field-with-icon" type="email" name='email' placeholder="Enter Your Email" defaultValue={emailaddr}/>
                  </label>
                </form>
              </div>

              {/* Password Change Form */}
              <div className="theme-form mt---0">
                <form onSubmit={handlePasswordChange}>
                  <label className="input-field password">
                    <input
                      className="field-with-icon"
                      type="password"
                      placeholder="Current Password"
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                    />
                    <span onClick={showPassword} className="eye-icon hide"></span>
                  </label>
                  <label className="input-field password">
                    <input
                      className="field-with-icon"
                      type="password"
                      placeholder="New Password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <span onClick={showPassword} className="eye-icon hide"></span>
                  </label>
                  <label className="input-field password">
                    <input
                      className="field-with-icon"
                      type="password"
                      placeholder="Confirm New Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <span onClick={showPassword} className="eye-icon hide"></span>
                  </label>
                  <button className="theme-btn gradient-btn" type="submit">Change Password</button>
                  {passwordMessage && <div className="message success">{passwordMessage}</div>}
                  {passwordError && <div className="message error">{passwordError}</div>}
                </form>
              </div>

            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Profile;
